import {getParams, getType, preloadedContentElement} from './attributes'

export const popoverContentHTMLMap = new Map()

function cacheMapKey(controller) {
  if (preloadedContentElement(controller)) {
    return controller.coupdoeilElement.uniqueId
  }
  return getType(controller) + getParams(controller)
}

export function getPopoverContentHTML(controller) {
  return popoverContentHTMLMap.get(cacheMapKey(controller))
}

export function setPopoverContentHTML(controller, value) {
  popoverContentHTMLMap.set(cacheMapKey(controller), value)
}

export function clearPopoverContentCache() {
  popoverContentHTMLMap.clear()
}
